import { useMemo } from 'react';
import { FormFields } from '@/types/entities/DataExtraction';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useGetDataExtractionList } from '@/hooks/useGetDataExtractionList';
// import { useGetAllExtractionIds } from '@/hooks/useGetAllExtractionIds';

export function useDataExtractionFetching(filters: FormFields, pagination: { page: number; limit: number }) {
	const { organization, company } = useApplicationContext();

	const searchParams = useMemo(() => {
		const params = {
			organization_id: organization?.id,
			company_id: company?.id,
			...filters,
			page: pagination.page,
			limit: pagination.limit
		};
		return params;
	}, [filters, organization, company, pagination.page, pagination.limit]);

	const { data, isLoading, refetch } = useGetDataExtractionList(searchParams);

	// const { data: allIds } = useGetAllExtractionIds({
	// 	organization_id: organization?.id || '',
	// 	company_id: company?.id || ''
	// });

	const listData = useMemo(
		() => ({
			rows: data?.rows || [],
			total: data?.total || 0,
			page: pagination.page,
			limit: pagination.limit
		}),
		[data, pagination]
	);

	const tableData = useMemo(
		() => ({
			...listData,
			items: listData.rows.map((item: any) => ({ ...item, key: item.id }))
		}),
		[listData]
	);

	return {
		data,
		isLoading,
		refetch,
		listData,
		tableData
		// fetchAllIds: () => allIds
	};
}
